import { debounce } from "lodash";
import { useMemo } from "react";

const useDebouncedSearch = (setSearch, setPagination) =>
  useMemo(
    () =>
      debounce((value) => {
        setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
        setSearch(value);
      }, 500),
    [setSearch, setPagination],
  );

export default useDebouncedSearch;
